export default __webpack_public_path__ + "static/media/doctors-3.80b20cb6.jpg";